module.exports = __webpack_public_path__ + "img/3_orong.3dee9b5f.png";